"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _product = require("@/api/product");
var _scenicSpot = require("@/api/scenic-spot");
var _vuex = require("vuex");
var _permission = require("@/utils/permission");
var _ZBKJIutil = require("@/utils/ZBKJIutil");
var _auth = require("@/utils/auth");
var _edit = _interopRequireDefault(require("@/components/Category/edit.vue"));
var _merchant = require("@/api/merchant");
var _systemForm = require("@/api/systemForm");
var _scenicSpot2 = _interopRequireDefault(require("@/mixins/scenic-spot"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'ProductProductAdd',
  directives: {
    // 计算是否滚动到最下面
    selectLoadMore: {
      bind: function bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          var condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  },
  mixins: [_scenicSpot2.default],
  //此js存放门票的部分函数方法
  components: {
    edit: _edit.default,
    Tinymce: _index.default
  },
  data: function data() {
    return {
      frontDomain: localStorage.getItem('frontDomain'),
      htmlKey: 0,
      url: '',
      labelarr: [],
      form: {
        scenicId: '',
        categoryId: ''
      },
      isDisabled: this.$route.params.isDisabled === '1' ? true : false,
      props2: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: true,
        emitPath: false,
        checkStrictly: true
      },
      props1: {
        children: 'childList',
        label: 'name',
        value: 'id',
        multiple: false,
        emitPath: false,
        checkStrictly: true
      },
      tabs: [],
      fullscreenLoading: false,
      props: {
        multiple: true
      },
      active: 0,
      grid2: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      currentTab: '1',
      isChoice: '',
      grid: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      },
      // 校验规则
      rules: {
        name: [{
          required: true,
          message: '请输入门票名称',
          trigger: 'blur'
        }],
        rysj: [{
          required: true,
          type: 'array',
          message: '请选择生效时间段'
        }],
        scenicId: [{
          required: true,
          message: '请选择所属景点',
          trigger: 'change'
        }],
        categoryId: [{
          required: true,
          message: '请选择平台分类',
          trigger: 'change'
        }],
        // tags: [{ required: true, type: 'array', message: '请选择标签', trigger: 'change' }],
        sort: [{
          required: true,
          message: '请输入排序值',
          trigger: 'blur'
        }],
        canVerificationNum: [{
          required: true,
          message: '请输入核销次数',
          trigger: 'blur'
        }],
        // image11: [{ required: true, message: '请上传缩略图', trigger: 'change' }],
        // sliderImages: [{ required: true, type: 'array', message: '请上传详情图', trigger: 'change' }],
        agreement: [{
          required: true,
          message: '请输入预定须知',
          trigger: 'blur'
        }],
        applicablePeriod: [{
          required: true,
          type: 'array',
          message: '请选择适用时间段',
          trigger: 'change'
        }],
        salesPrice: [{
          required: true,
          message: '请输入销售价',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          message: '请输入市场价',
          trigger: 'blur'
        }],
        withinXDays: [{
          required: true,
          message: '请输入有效期天数',
          trigger: 'blur'
        }],
        // productReturnRuleIds: [{ required: true, message: '请选择退款规则', trigger: 'change' }],
        'ext.returnKey': [{
          required: true,
          message: '请输入退款名称',
          trigger: 'blur'
        }],
        'ext.returnKeyValue': [{
          required: true,
          message: '请输入退款说明',
          trigger: 'blur'
        }],
        'ext.commissionKey': [{
          required: true,
          message: '请输入退款手续费名称',
          trigger: 'blur'
        }],
        'ext.commissionValue': [{
          required: true,
          message: '请输入退款手续费',
          trigger: 'blur'
        }],
        // limitBuyRuleIds: [{ required: true, message: '请选择限购规则', trigger: 'change' }],
        'ext.limitBuyDesc': [{
          required: true,
          message: '请输入限购规则描述',
          trigger: 'blur'
        }]
      },
      tempRoute: {},
      keyNum: 0,
      brandList: [],
      search: {
        limit: this.$constants.page.limit[0],
        page: 1
      },
      totalPage: 0,
      total: 0,
      loading: false,
      loadingBtn: false,
      multiples: true,
      productClassify: [],
      //平台门票分类
      upload: {
        videoIng: false // 是否显示进度条；
      },
      videoLink: '',
      //视频地址
      progress: 10,
      // 进度条默认0
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      },
      limitArr: [],
      //限购规则列表
      backArr: [],
      // 退货规则列表
      scenicAreaArr: [] //所属景点
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.bus.$emit('onTagsViewRefreshRouterView', this.$route.path);
    next();
  },
  computed: _objectSpread({
    visitedViews: function visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    }
  }, (0, _vuex.mapGetters)(['merPlatProductClassify', 'merProductClassify', 'productBrand', 'shippingTemplates'])),
  created: function created() {
    this.form.sliderImages = [];
    // initData 景点   getbacklist 限购   checkPermi 退货  规则
    this.initData();
    this.getbacklist();
    this.tempRoute = Object.assign({}, this.$route);
    console.log(this.$route.params);
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!(0, _permission.checkPermi)(['merchant:plat:product:category:cache:tree'])) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return this.$store.dispatch('product/getAdminProductClassify', {
              merchantType: 30
            });
          case 1:
            _context.n = 2;
            return this.$nextTick();
          case 2:
            if (!localStorage.getItem('merProductClassify') && (0, _permission.checkPermi)(['merchant:product:category:cache:tree'])) this.$store.dispatch('product/getMerProductClassify');
            if ((0, _permission.checkPermi)(['merchant:plat:product:brand:cache:list'])) this.$store.dispatch('product/getMerProductBrand');
            if (!localStorage.getItem('shippingTemplates')) this.$store.dispatch('product/getShippingTemplates');
            this.setTagsViewTitle();

            // 分类树赋值（确保数据已加载）
            this.productClassify = this.addDisabled(this.merPlatProductClassify);

            // 如果是编辑/详情，加载数据
            if (this.$route.params.id && this.$route.params.id != 0) {
              if ((0, _permission.checkPermi)(['merchant:product:info'])) this.getInfo();
            }
            this.getProductAuditSwitchInfo();
          case 3:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    checkPermi: _permission.checkPermi,
    initData: function () {
      var _initData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _scenicSpot.spotListApi)({
                page: 1,
                limit: 9999
              });
            case 1:
              res = _context2.v;
              console.log('返回景点的数据', res);
              this.scenicAreaArr = res.list;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function initData() {
        return _initData.apply(this, arguments);
      }
      return initData;
    }(),
    getbacklist: function getbacklist() {
      var _this = this;
      (0, _product.currentlimitListApi)().then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                console.log('退货', res);
                _this.limitArr = res.list;
              case 1:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      (0, _product.currentlreturnListApi)().then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(res) {
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.n) {
              case 0:
                console.log('限购', res);
                _this.backArr = res.list;
              case 1:
                return _context4.a(2);
            }
          }, _callee4);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    rysjChange: function rysjChange(e) {
      console.log('选中的时间', e);
    },
    // 全选时间段
    selectAllWeeks: function selectAllWeeks() {
      this.form.applicablePeriod = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
    },
    //系统表单数据
    getSystemFormList: function () {
      var _getSystemFormList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _yield$systemFormPage, list;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return (0, _systemForm.systemFormPageApi)({
                page: 1,
                limit: 999
              });
            case 1:
              _yield$systemFormPage = _context5.v;
              list = _yield$systemFormPage.list;
              this.$store.commit('mobildConfig/SET_SystemForm', list);
              // localStorage.setItem('systemFormList', JSON.stringify(list));
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function getSystemFormList() {
        return _getSystemFormList.apply(this, arguments);
      }
      return getSystemFormList;
    }(),
    //获取商户端商户门票审核开关信息
    getProductAuditSwitchInfo: function getProductAuditSwitchInfo() {
      var _this2 = this;
      (0, _merchant.productAuditSwitchInfoApi)().then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(res) {
          return _regenerator().w(function (_context6) {
            while (1) switch (_context6.n) {
              case 0:
                _this2.isSwitch = res.isSwitch;
                _this2.productSwitch = res.productSwitch;
              case 1:
                return _context6.a(2);
            }
          }, _callee6);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    hideEditDialog: function hideEditDialog() {
      var _this3 = this;
      this.editDialogConfig.prent = {};
      this.editDialogConfig.type = 0;
      this.editDialogConfig.visible = false;
      setTimeout(function () {
        _this3.$store.dispatch('product/getMerProductClassify');
      }, 200);
    },
    //视频上传前
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'video/mp4';
      var isLt2M = file.size / 10240 / 10240 < 2;
      if (!isJPG) {
        this.$message.error('上传视频只能是 mp4 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传视频不能超过 20MB!');
      }
      return isJPG && isLt2M;
    },
    // 上传
    handleUploadForm: function () {
      var _handleUploadForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(param) {
        var formData, data, loading, res, _t;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              formData = new FormData();
              data = {
                model: 'product',
                pid: 0
              };
              loading = this.$loading({
                lock: true,
                text: '上传中，请稍候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              formData.append('multipart', param.file);
              _context7.p = 1;
              _context7.n = 2;
              return (0, _ZBKJIutil.uploadImage)(formData, data);
            case 2:
              res = _context7.v;
              this.upload.videoIng = true;
              this.videoLink = res.url;
              this.progress = 100;
              loading.close();
              _context7.n = 4;
              break;
            case 3:
              _context7.p = 3;
              _t = _context7.v;
              loading.close();
            case 4:
              return _context7.a(2);
          }
        }, _callee7, this, [[1, 3]]);
      }));
      function handleUploadForm(_x4) {
        return _handleUploadForm.apply(this, arguments);
      }
      return handleUploadForm;
    }(),
    // 删除视频；
    delVideo: function delVideo() {
      this.$set(this, 'videoLink', '');
    },
    //处理平台门票分类数据（允许选择任意一级）
    addDisabled: function addDisabled(dropdownList) {
      var _this4 = this;
      var list = [];
      try {
        dropdownList.forEach(function (e, index) {
          var e_new = {
            id: e.id,
            name: e.name,
            level: e.level,
            pid: e.pid,
            isShow: e.isShow
          };
          // 如果有子分类，递归处理
          var hasChildren = e.childList && e.childList.length > 0;
          if (hasChildren) {
            var childList = _this4.addDisabled(e.childList);
            e_new = _objectSpread(_objectSpread({}, e_new), {}, {
              childList: childList
            });
          }
          list.push(e_new);
        });
      } catch (error) {
        return [];
      }
      return list;
    },
    /**
     * 复制门票转图片路径
     * @param sliderImage轮播图, attrValue规格
     */
    getShopImg: function () {
      var _getShopImg = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(sliderImage, attrValue) {
        var _this5 = this;
        var imgList, attrs, ShopImg, result;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              imgList = _toConsumableArray(JSON.parse(sliderImage));
              attrValue.map(function (item) {
                return imgList.push(item.image);
              });
              attrs = _toConsumableArray(new Set(imgList));
              ShopImg = [];
              attrs.map(function (item) {
                ShopImg.push({
                  key: item,
                  img: item
                });
              });
              _context8.n = 1;
              return this.getShopImgUpload(ShopImg, []);
            case 1:
              result = _context8.v;
              this.form.images = this.form.images.map(function (item, index) {
                if (result[index].key && item === result[index].key) {
                  return result[index].img;
                } else {
                  _this5.form.images.splice(index, 1);
                }
              });
              this.ManyAttrValue.map(function (item, index) {
                result.map(function (items, index) {
                  if (items.key && item.image === items.key) {
                    return item.image = items.img;
                  }
                });
              });
              this.fullscreenLoading = false;
            case 2:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function getShopImg(_x5, _x6) {
        return _getShopImg.apply(this, arguments);
      }
      return getShopImg;
    }(),
    getShopImgUpload: function () {
      var _getShopImgUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(attrs, arr) {
        var key, res, _t2, _t3;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _t2 = _regeneratorKeys(attrs);
            case 1:
              if ((_t3 = _t2()).done) {
                _context9.n = 3;
                break;
              }
              key = _t3.value;
              _context9.n = 2;
              return this.getImgData(attrs[key].img || attrs[key].sattDir);
            case 2:
              res = _context9.v;
              arr.push({
                key: attrs[key].img || attrs[key].imgsattDir,
                img: res
              });
              _context9.n = 1;
              break;
            case 3:
              return _context9.a(2, arr);
          }
        }, _callee9, this);
      }));
      function getShopImgUpload(_x7, _x8) {
        return _getShopImgUpload.apply(this, arguments);
      }
      return getShopImgUpload;
    }(),
    /**
     * 复制门票图片路径请求接口
     * @param imgUrl
     * @returns {Promise<any>}
     */
    getImgData: function getImgData(imgUrl) {
      var _this6 = this;
      return new Promise(function (resolve, reject) {
        shopImgUploadApi({
          imgUrl: imgUrl,
          respType: 1,
          uploadType: 1
        }).then(function (res) {
          if (res.errcode > 0) {
            _this6.fullscreenLoading = false;
            _this6.$message.error(res.errmsg);
            resolve('');
          } else {
            resolve(res.img_info.temp_img_url);
          }
        });
      });
    },
    getLabelarr: function getLabelarr(attr) {
      console.log('attr 标签方法', attr);
      this.labelarr = attr;
    },
    changeNodes: function changeNodes(data) {
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          if (!data[i].childList || data[i].childList.length < 1) {
            data[i].childList = undefined;
          } else {
            this.changeNodes(data[i].childList);
          }
        }
      }
      return data;
    },
    onChangeCategory: function onChangeCategory() {
      this.form.brandId = '';
      this.brandList = [];
      // this.getbrandList();
      this.brandList.push({
        name: '其他',
        id: 0
      });
    },
    // 下拉加载更多
    selectLoadMore: function selectLoadMore() {
      this.search.page = this.search.page + 1;
      if (this.search.page > this.totalPage) return;
      // this.getbrandList(); // 请求接口
    },
    // 远程搜索
    remoteMethod: function remoteMethod(query) {
      var _this7 = this;
      this.loading = true;
      this.search.brandName = query;
      this.search.page = 1;
      setTimeout(function () {
        _this7.loading = false;
        // this.getbrandList(); // 请求接口
      }, 200);
    },
    // 品牌列表
    // getbrandList() {
    //   this.search.cid = this.form.categoryId;
    //   brandListApi(this.search).then((res) => {
    //     this.totalPage = res.totalPage;
    //     this.total = res.total;
    //     this.brandList = this.brandList.concat(res.list);
    //   });
    // },
    proving1: function proving1(e) {
      this.form.sort = e.target.value.replace(/[^\.\d]/g, '');
      this.form.sort = e.target.value.replace('.', '');
    },
    handleCloseCoupon: function handleCloseCoupon(tag) {
      this.form.coupons.splice(this.form.coupons.indexOf(tag), 1);
      this.form.couponIds.splice(this.form.couponIds.indexOf(tag.id), 1);
    },
    setTagsViewTitle: function setTagsViewTitle() {
      if (this.$route.params.id && this.$route.params.id != 0) {
        var title = this.isDisabled ? '门票详情' : '编辑门票';
        var route = Object.assign({}, this.tempRoute, {
          title: "".concat(title, "-").concat(this.$route.params.id)
        });
        this.$store.dispatch('tagsView/updateVisitedView', route);
      }
    },
    // 详情
    getInfo: function getInfo() {
      var _this8 = this;
      this.fullscreenLoading = true;
      (0, _scenicSpot.ticketDetailApi)(this.$route.params.id).then(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(res) {
          return _regenerator().w(function (_context0) {
            while (1) switch (_context0.n) {
              case 0:
                _context0.n = 1;
                return _this8.getData(res, 'add');
              case 1:
                _this8.fullscreenLoading = false;
              case 2:
                return _context0.a(2);
            }
          }, _callee0);
        }));
        return function (_x9) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this8.fullscreenLoading = false;
      });
    },
    handleRemove: function handleRemove(i) {
      this.form.sliderImages.splice(i, 1);
    },
    // 编辑门票 重新赋值
    getData: function getData(res) {
      var _this9 = this;
      var dayMapping = {
        1: '周一',
        2: '周二',
        3: '周三',
        4: '周四',
        5: '周五',
        6: '周六',
        7: '周日'
      };
      console.log('获取传进来的值123123', res);
      this.$nextTick(function () {
        _this9.form.name = res.name;
        _this9.form.scenicId = res.scenicId;
        _this9.form.categoryId = res.categoryId ? Number(res.categoryId) : null;
        _this9.labelarr = res.tags;
        _this9.tags = res.tags;
        _this9.form.sort = res.sort;
        _this9.form.canVerificationNum = res.canVerificationNum;
        _this9.form.image = res.image;
        _this9.form.salesPrice = res.salesPrice;
        _this9.form.price = res.price;
        _this9.form.withinXDays = res.withinXDays;
        _this9.form.agreement = res.agreement;
        _this9.form.ext = res.ext;
        _this9.form.limitBuyRuleIds = res.limitBuyRuleIds;
        _this9.form.productReturnRuleIds = res.productReturnRuleIds;
        _this9.form.applicablePeriod = res.applicablePeriod.map(function (day) {
          return dayMapping[day];
        });
      });
      var vid = JSON.parse(res.imagePage)[0];
      if (this.getFileType(vid) == 'video') {
        //如果返回数据轮播图的第一张是视频，就将其赋值给videoLink做渲染，同时将其在轮播图中删除
        this.videoLink = this.getFileType(vid) == 'video' ? vid : '';
        this.form.sliderImages = JSON.parse(res.imagePage);
        this.form.sliderImages.splice(0, 1);
      } else {
        this.form.sliderImages = JSON.parse(res.imagePage);
      }
    },
    //保存接口数据更新
    getFromData: function getFromData() {
      var _this0 = this;
      if (this.videoLink) {
        //如果有视频主图，将视频链接插入到轮播图第一的位置
        this.form.sliderImages.unshift(this.videoLink);
      }
      var time = this.scenicAreaArr.find(function (item) {
        return item.id == _this0.form.scenicId;
      });
      var data = _objectSpread(_objectSpread({}, this.form), {}, {
        tags: this.labelarr,
        categoryId: this.form.categoryId ? Number(this.form.categoryId) : null,
        imagePage: JSON.stringify(this.form.sliderImages),
        // admissionStartTime:this.form.rysj[0],
        // admissionEndTime:this.form.rysj[1],
        admissionStartTime: time.admissionStartTime,
        admissionEndTime: time.admissionEndTime,
        ticketType: 1
      });
      console.log('编辑的数据', data);
      return data;
    },
    //是否自动上架
    automaticListing: function automaticListing() {
      var _this1 = this;
      this.$confirm(this.productSwitch ? '审核通过之后是否自动上架？' : '操作之后是否自动上架？', '提示', {
        confirmButtonText: '上架',
        cancelButtonText: '不用了',
        type: 'warning',
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        customClass: 'deleteConfirm'
      }).then(function () {
        _this1.form.isAutoUp = true;
        _this1.postData();
      }).catch(function (action) {
        if (action === 'cancel') {
          _this1.form.isAutoUp = false;
          _this1.postData();
          // 调用取消按钮的方法
        } else if (action === 'close') {
          // 调用关闭按钮的方法
        }
      });
    },
    //保存并审核
    handleSubmitAndAudit: function handleSubmitAndAudit(name) {
      var _this10 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this10.form.isAutoSubmitAudit = true;
          _this10.automaticListing();
        } else {
          if (!_this10.form.name || !_this10.form.cateId || !_this10.form.keyword || !_this10.form.unitName || !_this10.form.intro || !_this10.form.image || !_this10.form.sliderImages) {
            _this10.$message.warning('请填写完整门票信息！');
          }
        }
      });
    },
    // 保存
    handleSubmit: function handleSubmit(name) {
      var _this11 = this;
      this.$refs[name].validate(function (valid, msg) {
        if (valid) {
          _this11.postData();
        } else {
          _this11.$message.warning('请填写完整门票信息！');
        }
      });
    },
    // 新增保存数据
    postData: function postData() {
      var _this12 = this;
      var dayMapping = {
        '周一': 1,
        '周二': 2,
        '周三': 3,
        '周四': 4,
        '周五': 5,
        '周六': 6,
        '周日': 7
      };
      this.loadingBtn = true;
      var data = this.getFromData();
      var dataInfo = _objectSpread(_objectSpread({}, data), {}, {
        applicablePeriod: data.applicablePeriod.map(function (day) {
          return dayMapping[day];
        }),
        id: this.$route.params.id || null
      });
      data.applicablePeriod = data.applicablePeriod.map(function (day) {
        return dayMapping[day];
      });
      parseFloat(this.$route.params.id) > 0 ? (0, _scenicSpot.ticketUpdateApi)(dataInfo).then(/*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(res) {
          return _regenerator().w(function (_context1) {
            while (1) switch (_context1.n) {
              case 0:
                _this12.$message.success('编辑成功');
                setTimeout(function () {
                  _this12.$router.push({
                    path: '/scenic-spot/list'
                  });
                }, 500);
                _this12.closeSelectedTag();
                _this12.loadingBtn = false;
              case 1:
                return _context1.a(2);
            }
          }, _callee1);
        }));
        return function (_x0) {
          return _ref5.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this12.loadingBtn = false;
      }) : (0, _scenicSpot.ticketCreateApi)(dataInfo).then(/*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(res) {
          return _regenerator().w(function (_context10) {
            while (1) switch (_context10.n) {
              case 0:
                _this12.$message.success('新增成功');
                setTimeout(function () {
                  _this12.$router.push({
                    path: '/scenic-spot/list'
                  });
                }, 500);
                _this12.closeSelectedTag();
                _this12.loadingBtn = false;
              case 1:
                return _context10.a(2);
            }
          }, _callee10);
        }));
        return function (_x1) {
          return _ref6.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this12.loadingBtn = false;
      });
    },
    isActive: function isActive(route) {
      return route.path === this.$route.path;
    },
    closeSelectedTag: function closeSelectedTag() {
      var that = this;
      that.$store.dispatch('tagsView/delView', that.$route).then(function (_ref7) {
        var visitedViews = _ref7.visitedViews;
        if (that.isActive(that.$route)) {
          that.toLastView(visitedViews, that.$route);
        }
      });
    },
    toLastView: function toLastView(visitedViews, view) {
      var latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Dashboard') {
          // to reload home page
          this.$router.replace({
            path: '/redirect' + view.fullPath
          });
        } else {
          this.$router.push('/');
        }
      }
    },
    // 表单验证
    validate: function validate(prop, status, error) {
      if (status === false) {
        this.$message.warning(error);
      }
    },
    getFileType: function getFileType(fileName) {
      // 后缀获取
      var suffix = '';
      // 获取类型结果
      var result = '';
      try {
        var flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = '';
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return false;
      }
      suffix = suffix.toLocaleLowerCase();
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
      // 进行图片匹配
      result = imglist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'image';
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
      result = videolist.find(function (item) {
        return item === suffix;
      });
      if (result) {
        return 'video';
      }
      // 其他 文件类型
      return 'other';
    }
  }
};